var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7999 8.40001C8.7999 9.08001 8.2799 9.60001 7.5999 9.60001C6.9199 9.60001 6.3999 9.08001 6.3999 8.40001C6.3999 7.72001 6.9199 7.20001 7.5999 7.20001C8.2799 7.20001 8.7999 7.72001 8.7999 8.40001ZM12.3999 7.20001C11.7199 7.20001 11.1999 7.72001 11.1999 8.40001C11.1999 9.08001 11.7199 9.60001 12.3999 9.60001C13.0799 9.60001 13.5999 9.08001 13.5999 8.40001C13.5999 7.72001 13.0799 7.20001 12.3999 7.20001ZM15.9999 8.40001C15.9999 7.72001 16.5199 7.20001 17.1999 7.20001C17.8799 7.20001 18.3999 7.72001 18.3999 8.40001C18.3999 9.08001 17.8799 9.60001 17.1999 9.60001C16.5199 9.60001 15.9999 9.08001 15.9999 8.40001Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesImage);
export default __webpack_public_path__ + "static/media/ellipses-image.08d79714a7bdab26168ac16618c91326.svg";
export { ForwardRef as ReactComponent };